import { addApiPrefix } from 'as-ui-kit/utils/urls';
import { getFetchOptions, handleResult } from 'as-ui-kit/utils/http';
import { snakeToPascalObj, camelToSnakeObj } from 'as-ui-kit/utils/adapters';
import { catchWithMsg, handlePayByCardResult, handlePayFromVirtualResult } from 'utils/http';

export const init = (appUrl) =>
    fetch(addApiPrefix('/gw/vandamus/public/v1/active_truckers/init', appUrl), getFetchOptions())
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const search = (rq, lang, appUrl) =>
    fetch(addApiPrefix(`/gw/vandamus/public/v1/active_truckers/search?lang=${lang}`, appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const payFromVirtual = (rq, appUrl) =>
    fetch(addApiPrefix('/gw/vandamus/webapi/v1/active_truckers/pay', appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'))
        .then(handlePayFromVirtualResult);

export const payByCard = (rq, appUrl) =>
    fetch(addApiPrefix('/gw/vandamus/webapi/v1/active_truckers/pay/by_card', appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'))
        .then(handlePayByCardResult);

export const writeEvent = (rq, appUrl) =>
    fetch(addApiPrefix('/gw/vandamus/public/v1/active_truckers/event', appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'));

export const getCoefficients = (rq, appUrl) =>
    fetch(addApiPrefix('/gw/vandamus/webapi/v1/active_truckers/rating_params/get', appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const saveCoefficients = (rq, appUrl) =>
    fetch(addApiPrefix('/gw/vandamus/webapi/v1/active_truckers/rating_params/upsert', appUrl), getFetchOptions(camelToSnakeObj(rq), 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);
